// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"353":"contact","594":"about"}[chunkId] + "." + {"353":"f790cfb9","594":"b99ab9ac"}[chunkId] + ".js";
};